"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _react = _interopRequireWildcard(require("react")),
    _reactPlacesAutocomplete = _interopRequireDefault(require("react-places-autocomplete")),
    _Dropdown = _interopRequireDefault(require("../../Dropdown"));

function getSearchOptions() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
      b = a.coords;
  return b ? {
    location: new google.maps.LatLng(b.latitude, b.longitude),
    radius: 2e3,
    types: ["geocode"]
  } : {};
}

function buildAddressLabel(a) {
  var b = a.description,
      c = b.split(","),
      d = c[0],
      e = c.slice(1, c.length);
  return {
    label: "".concat(d, ", ").concat(e),
    value: a
  };
}

function buildSuggestionList(a) {
  return a.map(buildAddressLabel);
}

var onSelectAddress = function onSelectAddress(a, b) {
  return function (c) {
    var d = c.value;
    b(!0), a(d).onClick();
  };
},
    onSearch = function onSearch(a) {
  return function (b) {
    a({
      target: {
        value: b
      }
    });
  };
};

function LocationSelector(a) {
  var b = a.addressString,
      c = a.onChangeAddress,
      d = a.onSelect,
      e = a.userLocation,
      f = a.placeholder,
      g = a.isManualEntry,
      h = a.disabled,
      i = a.requestUserLocation,
      j = a.id,
      k = a.dropdownType,
      l = (0, _react.useState)(!1),
      m = (0, _slicedToArray2["default"])(l, 2),
      n = m[0],
      o = m[1];
  return (0, _react.useEffect)(function () {
    o(!1);
  }, [g, h]), _react["default"].createElement(_reactPlacesAutocomplete["default"], {
    value: b,
    onChange: c,
    onSelect: d,
    searchOptions: getSearchOptions(e)
  }, function (a) {
    var b = a.getInputProps,
        c = a.suggestions,
        d = a.getSuggestionItemProps,
        e = a.loading,
        l = b() || {},
        m = l.onChange;
    return _react["default"].createElement(_Dropdown["default"], {
      id: j,
      options: buildSuggestionList(c),
      isSearchable: !0,
      onInputChange: onSearch(m),
      onChange: onSelectAddress(d, o),
      isLoading: e,
      disabled: n || g || h,
      placeholder: n || g ? "" : f,
      value: null,
      noResultsText: "We couldn't find your address",
      onFocus: i,
      type: k
    });
  });
}

var _default = (0, _react.memo)(LocationSelector);

exports["default"] = _default;